// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-timeline__logo{border-radius:20%;width:25px;height:25px;position:absolute;margin-top:-2px}[dir=ltr] .provider-timeline__logo{left:-15px}[dir=rtl] .provider-timeline__logo{right:-15px}.provider-timeline__titles{-webkit-margin-start:35px;margin-inline-start:35px}", ""]);
// Exports
module.exports = exports;
